import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { vars } from '../../theme';
import { Z_INDEX } from '../../styles/variables';
import { skBounceDelay } from '../../styles/animations';

const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: ${Z_INDEX.SPLASH};
    background-color: ${vars.colors.surface.container};
`;

const RootSpinner = styled.div`
    margin: 0 auto;
    width: 100px;
    text-align: center;

    div {
        width: 16px;
        height: 16px;
        background-color: ${vars.colors.base.neutral};
        border-radius: ${vars.radius.full};
        display: inline-block;
        margin-right: 5px;
        animation: ${skBounceDelay} 1.7s infinite ease-in-out both;
    }
`;

const Item1 = styled.div`
    animation-delay: -0.6s !important;
`;

const Item2 = styled.div`
    animation-delay: -0.4s !important;
`;

const Item3 = styled.div`
    animation-delay: -0.2s !important;
`;

export interface Props {
    /** CSS class forwarded to the root container element. */
    className?: string;
}

const HBSplashScreen = ({ className, children }: PropsWithChildren<Props>) => {
    return (
        <Container className={className} data-testid="hb-splashscreen">
            {children}
            <RootSpinner>
                <Item1 />
                <Item2 />
                <Item3 />
                <div />
            </RootSpinner>
        </Container>
    );
};

export default HBSplashScreen;
